import React from "react";
import { GoHome } from "react-icons/go";
import {
  RiFolderLine,
  RiSettings5Line,
  RiLogoutBoxRLine,
} from "react-icons/ri";
import { LuLayoutDashboard } from "react-icons/lu";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { VscFeedback, VscInfo, VscListUnordered } from "react-icons/vsc";
import { PiUserList } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import { Col, Nav, NavDropdown, Offcanvas, Row } from "react-bootstrap";
import { NavLinkWithLocale } from "../index";
import style from "./HeaderBar.module.css";

const LoggedHamburgerMenu = ({ user, handleLogOut, handleNavLinkClick }) => {
  const { t, i18n } = useTranslation();
  return (
    <Offcanvas.Body>
      <Nav>
        <Row className="flex-column g-3 mt-1">
          <Col className={style.bgWorkspace}>
            <NavLinkWithLocale
              onClick={handleNavLinkClick}
              className={style.mobileLinks}
              to="/colormatch"
            >
              {t("Workspace")}
            </NavLinkWithLocale>
          </Col>
          <Col className={style.bgSearch}>
            <NavLinkWithLocale
              onClick={handleNavLinkClick}
              className={style.mobileLinks}
              to="/search"
            >
              {t("Search Balloons")}
            </NavLinkWithLocale>
          </Col>
        </Row>
        <hr />
        <NavLinkWithLocale
          onClick={handleNavLinkClick}
          className={`${style.mobileLinks}`}
          to="/profile/palettes"
        >
          <RiFolderLine size="1.6rem" />
          {t("Saved Palettes")}
        </NavLinkWithLocale>
        <NavLinkWithLocale
          onClick={handleNavLinkClick}
          className={`${style.mobileLinks}`}
          to="/profile"
        >
          <RiSettings5Line size="1.6rem" />
          {t("Account Settings")}
        </NavLinkWithLocale>
        {user && user.role === "1" && (
          <NavLinkWithLocale
            onClick={handleNavLinkClick}
            className={`${style.mobileLinks}`}
            to="/dashboard"
          >
            <LuLayoutDashboard size="1.6rem" />
            Dashboard
          </NavLinkWithLocale>
        )}
        {/* <NavLinkWithLocale
          onClick={handleNavLinkClick}
          className={`${style.mobileLinks}`}
          to="/"
        >
          <GoHome size="1.6rem" />
          {t("Home")}
        </NavLinkWithLocale> */}
        <NavDropdown
          className={`${style.mobileLinks} ${style.help}`}
          title={
            <>
              <IoIosHelpCircleOutline size="1.6rem" />
              {t("Help")}
            </>
          }
        >
          <NavDropdown.Item
            className={style.mobileSublinks}
            onClick={handleNavLinkClick}
            href={`/${i18n.language}/sendFeedback`}
          >
            <VscFeedback size="1.3rem" />
            {t("Feedback")}
          </NavDropdown.Item>
          <NavDropdown.Item
            className={style.mobileSublinks}
            onClick={handleNavLinkClick}
            href={`/${i18n.language}/reportAnIssue`}
          >
            <VscInfo size="1.3rem" />
            {t("Report an Issue")}
          </NavDropdown.Item>
          <NavDropdown.Item
            className={style.mobileSublinks}
            onClick={handleNavLinkClick}
            href={`/${i18n.language}/supportedBrands`}
          >
            <VscListUnordered size="1.3rem" />
            {t("Supported Brands")}
          </NavDropdown.Item>
          <NavDropdown.Item
            className={style.mobileSublinks}
            onClick={handleNavLinkClick}
            href={`/${i18n.language}/product`}
          >
            <PiUserList size="1rem" />
            {t("Plans & Pricing")}
          </NavDropdown.Item>
          {/* <NavDropdown.Item
            className={style.mobileSublinks}
            onClick={handleNavLinkClick}
            href="#"
          >
            <IoBookOutline size="1.3rem" />
            {t("FAQ")}
          </NavDropdown.Item> */}
        </NavDropdown>
        <hr />
        <NavLinkWithLocale
          onClick={handleNavLinkClick}
          className={style.sublinks}
          to="/terms"
        >
          {t("Terms")}
        </NavLinkWithLocale>
        <NavLinkWithLocale
          onClick={handleNavLinkClick}
          className={style.sublinks}
          to="/privacyPolicy"
        >
          {t("Privacy Policy")}
        </NavLinkWithLocale>
        <NavLinkWithLocale
          onClick={handleNavLinkClick}
          className={style.sublinks}
          to="/contactUs"
        >
          {t("Contact Us")}
        </NavLinkWithLocale>
        <hr />
        {user && (
          <NavLinkWithLocale
            onClick={handleLogOut}
            className={`${style.mobileLinks}`}
          >
            <RiLogoutBoxRLine size="1.6rem" />
            {t("Log out")}
          </NavLinkWithLocale>
        )}
      </Nav>
    </Offcanvas.Body>
  );
};

export default LoggedHamburgerMenu;
